const TURNSTILE_SCRIPT_ID = "cf-turnstile-script";
const TURNSTILE_SCRIPT_SRC =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

export const TURNSTILE_SITE_KEY =
  process.env.VUE_APP_CLOUDFLARE_TURNSTILE_SITE_KEY || "";

let scriptLoadPromise = null;

export function loadTurnstileScript() {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }

  if (window.turnstile) {
    return Promise.resolve();
  }

  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  const existingScript = document.getElementById(TURNSTILE_SCRIPT_ID);
  if (existingScript) {
    scriptLoadPromise = new Promise((resolve, reject) => {
      const waitForTurnstile = () => {
        if (window.turnstile) {
          resolve();
          return;
        }
        setTimeout(waitForTurnstile, 50);
      };
      existingScript.addEventListener("load", waitForTurnstile);
      existingScript.addEventListener("error", reject);
      waitForTurnstile();
    });
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = TURNSTILE_SCRIPT_ID;
    script.src = TURNSTILE_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Cloudflare Turnstile"));
    document.head.appendChild(script);
  });

  return scriptLoadPromise;
}
